
export enum ViewType {
  HOME = 'home',
  CHAT = 'chat',
  IMAGE = 'image',
  VIDEO = 'video',
  SEARCH = 'search',
  MAPS = 'maps',
  AUDIO = 'audio',
  DICTIONARY = 'dictionary',
  TRANSLATE = 'translate',
  SUBSCRIPTION = 'subscription',
  AUTH = 'auth',
  PROFILE = 'profile'
}

export type AppLanguage = 'en' | 'zo' | 'my';
export type AppTheme = 'light' | 'dark' | 'system';
export type ChatbotPersonality = 'professional' | 'friendly' | 'creative' | 'concise';

export interface UserProfile {
  isAuthenticated: boolean;
  username?: string;
  email?: string;
  isPro: boolean;
  dailyCreditsUsed: number;
  lastResetDate: string;
  language: AppLanguage;
  theme: AppTheme;
  personality: ChatbotPersonality;
}

export interface SavedWord {
  word: string;
  definition: string;
  timestamp: number;
}

export const FREE_DAILY_LIMIT = 10;
export const GUEST_DAILY_LIMIT = 5;
export const PRO_DAILY_LIMIT = 1000;

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  image?: string;
  timestamp: number;
  sources?: Array<{ title: string; uri: string }>;
  thought?: string;
}

export interface GeneratedImage {
  id: string;
  url: string;
  prompt: string;
  timestamp: number;
  isPro: boolean;
}

export interface GeneratedVideo {
  id: string;
  url: string;
  prompt: string;
  status: 'processing' | 'completed' | 'failed';
  timestamp: number;
}
